import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core'
import { ArtistPageTypes } from 'src/app/reducers/shell.reducer'

@Component({
    selector: 'app-artist-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./artist-footer.component.scss'],
  template: `
    @if (page) {
      <div class="bottom-toolbar mat-elevation-z4">

        <div
          class="bottom-toolbar-item"
          [class.selected]="page === 'sales'"
        >
          <button mat-button routerLink="sales">
            <span class="bottom-toolbar-content">
              <mat-icon>queue_music</mat-icon>
              <span class="caption">作品動向</span>
            </span>
          </button>
        </div>

        <div
          class="bottom-toolbar-item"
          [class.selected]="page === 'data'"
        >
          <button mat-button routerLink="data">
            <span class="bottom-toolbar-content">
              <mat-icon>trending_up</mat-icon>
              <span class="caption">データ</span>
            </span>
          </button>
        </div>

        <div
          class="bottom-toolbar-item"
          [class.selected]="page === 'graph'"
        >
          <button mat-button routerLink="graph">
            <span class="bottom-toolbar-content">
              <mat-icon>insert_chart_outlined</mat-icon>
              <span class="caption">グラフ</span>
            </span>
          </button>
        </div>

        <div
          class="bottom-toolbar-item"
          [class.selected]="page === 'charts'"
        >
          <button mat-button routerLink="charts">
            <span class="bottom-toolbar-content">
              <mat-icon>star_border</mat-icon>
              <span class="caption">チャート</span>
            </span>
          </button>
        </div>

        <div
          class="bottom-toolbar-item"
          [class.selected]="page === 'demographics'"
        >
          <button mat-button routerLink="demographics">
            <span class="bottom-toolbar-content">
              <mat-icon>face</mat-icon>
              <span class="caption">デモグラ</span>
            </span>
          </button>
        </div>

      </div>
    }
    `,
    standalone: false
})
export class ArtistFooterComponent implements OnInit {
  @Input()
  page: ArtistPageTypes

  constructor() {}

  ngOnInit() {}
}
